<div class="container-fluid main">


  <div class="row">
    <div class="success-message m-5">
      <div
        *ngIf="success && message"
        class="alert alert-success alert-dismissible fade show w-75"
        role="alert"
      >
        {{ message }}
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="row table_title mt-5 background-white w-100">
      <div class="row w-100 p-3 mx-5">
        <div class="col mx-5 px-5 title">
          <h3 class="my-4">{{ title }}</h3>
        </div>
        <div class="col-6 px-2 w-100">
          <div class=" mx-5 px-5 w-100">
            <a
              routerLink="/create/{{ type }}"
              class="btn btn-primary btn-lg active mx-5 my-3 create_btn"
              role="button"
              aria-pressed="true"
              >New Account</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center m-5 p-5 text-primary" *ngIf="!data">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="row table_col" *ngIf="data">
    <div class="col background-white py-2 px-5 ">
      <table class="table table-striped ">
        <thead w-100 class="table_head">
          <tr>
            <th scope="col">Email</th>
            <th scope="col">User role</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody p-5>
          <tr
            *ngFor="
              let row of data
                | paginate: { itemsPerPage: count, currentPage: page }
            "
          >
            <td>{{ row.email }}</td>
            <td>{{ row.adminRole }}</td>
            <td>
              <div class="dropdown">
                <button
                  class="btn btn-outline-info dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  OPTIONS
                </button>
                <div
                  class="dropdown-menu options"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a class="dropdown-item items" id="edit" (click)="getUrl(row)"
                    >Edit</a
                  >
                  <a
                    id="delete"
                    class="dropdown-item "
                    (click)="setAction(row, 'delete')"
                    data-toggle="modal"
                    data-target="#exampleModalLong"
                    >Delete</a
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation example">
        <pagination-controls (pageChange)="page = $event"></pagination-controls>
      </nav>
      <!-- Modal -->
      <div
        class="modal fade"
        id="exampleModalLong"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-info" id="exampleModalLongTitle">
                {{ action }} Account
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              Are you sure you want to {{ action | lowercase }} this account?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary status"
                data-dismiss="modal"
                (click)="deleteAccount(selectedUser._id)"
              >
                {{ action }} Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
